import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {speedTestAdsAuditLog_template} from "../components/templates/speedTestAdsAuditLog_template";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class speedTestAdsAuditLog extends vnModule_knockoutJS{

    public XHRHdl: XMLHttpRequestHandler;
    protected speedTestAdsAuditLog: speedTestAdsAuditLog_template;
    protected pagination: pagination_template;

    protected getModuleName(){

        return "speedTestAdsAuditLog";
    }

    buildContent() : Array<Element>{

        this.speedTestAdsAuditLog = new speedTestAdsAuditLog_template("speedTestAdsAuditLog", this.viewModel, this);
        return [this.speedTestAdsAuditLog.build()];
    }

    public fillPage() : void {

        this.speedTestAdsAuditLog.setStatusFilterItems();

        this.getListData();
    }

    protected getListData(): void {

        if (this.XHRHdl) {

            this.XHRHdl.cancelAndReset();
        }

        let id = this.getVnAppZone().app.params.id || null;

        // LOADING : starts
        this.loadingIn(this.speedTestAdsAuditLog.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/speedTest/configAdsAudit/logs/' + id;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.speedTestAdsAuditLog.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onDataRequestReturn(req, obj): Function {

        return function(){

            obj.manageResponse(req, obj, function(){

                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateList(responseParsed);
                }
            });
            obj.loadingOut(obj.speedTestAdsAuditLog.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any): void {

        this.speedTestAdsAuditLog.setLogs(responseParsed.data);

        // update the paginator
        this.speedTestAdsAuditLog.setPaginationTotalCount(responseParsed.totalCount);
    }

    protected paginationOnPageClick(): void {

        this.getListData();
    }

    public listReorder(): void {

        this.getListData();
    }

    protected filterSimpleOnChange(): void {

        this.speedTestAdsAuditLog.resetPageNumber();
        this.getListData();
    }

    protected filterSimpleCancel(): void {

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(){

        this.getListData();
    }

    public dataReorder(id) {

        this.getListData();
    }

    protected cancel(){


        page.redirect('/speed_test/config_ads_audit/');
    }
}


// WEBPACK FOOTER //
// ./js/modules/speedTestAdsAuditLog.ts